import { STATUS_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FormatRule, EvaluateHandler } from '../../../evaluate-format-rule/types.tsx';
import type { TransformedStatusField } from '../types.tsx';

// TODO: update to compare the status id
const evaluateHandler: EvaluateHandler<TransformedStatusField> = {
	IS: (field, value) => field.statusId === value,
	IS_NOT: (field, value) => field.statusId !== value,
	HAS_ANY_OF: (field, value) => Array.isArray(value) && Boolean(value?.includes(field.statusId)),
};

const evaluateFormatRule: FormatRule<TransformedStatusField> = ({ field, operator, value }) => {
	const evaluateHandlerFn = evaluateHandler[operator];
	if (!evaluateHandlerFn) return false;
	return evaluateHandlerFn(field, value);
};

export const statusEvaluateFormatRule = {
	[STATUS_TYPE]: evaluateFormatRule,
};
